import { registerEnumType } from '@warebee/shared/util-backend-only-types';

export enum ImportJobImportType {
  LAYOUT = 'LAYOUT',
  ASSIGNMENT = 'ASSIGNMENT',
  ITEM_SET = 'ITEM_SET',
  ORDER_SET = 'ORDER_SET',
  ASSIGNMENT_POLICY = 'ASSIGNMENT_POLICY',
  ACTIVITY_FEED = 'ACTIVITY_FEED',
  INVENTORY_SNAPSHOT = 'INVENTORY_SNAPSHOT',
  ACTIVITY_PLAN = 'ACTIVITY_PLAN',
  // TODO distinguish between DatasetObjectType, DatasetTableType and ImportJobImportType
  CONVERTED_LAYOUT = 'CONVERTED_LAYOUT',
  GENERIC = 'GENERIC',
}

registerEnumType(ImportJobImportType, {
  name: 'ImportJobImportType',
});

export const ALL_IMPORT_JOB_IMPORT_TYPES: ImportJobImportType[] = [
  ImportJobImportType.LAYOUT,
  ImportJobImportType.ASSIGNMENT,
  ImportJobImportType.ITEM_SET,
  ImportJobImportType.ORDER_SET,
  ImportJobImportType.ASSIGNMENT_POLICY,
  ImportJobImportType.ACTIVITY_FEED,
  ImportJobImportType.INVENTORY_SNAPSHOT,
  ImportJobImportType.ACTIVITY_PLAN,
  ImportJobImportType.CONVERTED_LAYOUT,
  ImportJobImportType.GENERIC,
];
